import * as React from "react";
import { REFINED } from "../../risikoanalyseStep/tokens";
import { teilnehmerKurz, teilnehmerText } from "../v4/austauschAnzeige";
import type { ZeilenAustausch } from "./unifiedRows";

/**
 * Das Austausch-Kennzeichen der Vorgangsliste (T-302): „Austausch · DC, CLL".
 *
 * Saschas eigentliches Problem (Ticket 13.10.2026, Seite /vorgaenge, Ansicht
 * Team) war die LISTE — sehen, wo eine Rücksprache ansteht, ohne jeden
 * Vorgang zu öffnen. PO 01.11.2026: „nicht nur A, sondern ‚Austausch'
 * anzeigen, und beim Hover sieht man genau, mit wem." Das Kennzeichen nennt
 * die Kürzel; der Tooltip alle Namen, Externe als „(extern)".
 *
 * Inline gestylt wie die Art-Pille (`VorgaengeMo`) — die Liste lebt nicht
 * unter `.vg4-*`, und das Kennzeichen soll in Tabelle und Karte gleich aussehen.
 */
export function austauschChipTitel(austausch: ZeilenAustausch): string {
    const namen = teilnehmerText(austausch.personen);
    const wo = austausch.anzahl > 1 ? ` — an ${austausch.anzahl} To-dos offen` : "";
    return namen ? `Austausch mit ${namen}${wo}` : `Austausch offen${wo}`;
}

export const AustauschChip: React.FC<{ austausch: ZeilenAustausch; max?: number }> = ({ austausch, max = 2 }) => {
    const titel = austauschChipTitel(austausch);
    const kurz = teilnehmerKurz(austausch.personen, max);
    return (
        <span
            className="vg-austausch-chip"
            title={titel}
            aria-label={titel}
            style={{
                display: "inline-block",
                maxWidth: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                verticalAlign: "middle",
                padding: "1px 8px",
                borderRadius: 999,
                fontSize: "0.72rem",
                fontWeight: 700,
                whiteSpace: "nowrap",
                cursor: "help",
                backgroundColor: REFINED.aub50,
                color: REFINED.aub,
                border: `1px solid ${REFINED.aub100}`,
            }}
        >
            Austausch{kurz ? ` · ${kurz}` : ""}
        </span>
    );
};
